<template>
    <div id="container">
        <!-- <div class="ion-margin">
            <Dropdown v-model="myShip" :options="myShips" optionLabel="name" dataKey="value" placeholder="Filter Ship"
                :required="false" :filter="true" filterPlaceholder="Filter Ship" @change="filterChange()"
                style="width:100%" />
        </div> -->
        
        
        <ion-grid>
            <ion-row>
                <ion-col size="6">
                    <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company"  style="width:100%"/>
                </ion-col>
                <ion-col size="6">
                    <ion-item>
                        <ion-label position="floating">Client <span class="required">*</span></ion-label>
                        <ion-select mode="ios" interface="action-sheet" @IonChange="clientChanged" v-model="postData['client_id']">
                            <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col size="6">
                    <ion-item>
                        <ion-label position="floating">Ship <span class="required">*</span></ion-label>
                        <ion-select mode="ios" interface="action-sheet" v-model="postData['ship_id']">
                            <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col size="6">
                    <ion-button @click="loadData(0)">Filter</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!-- <ion-button shape="round" fill="outline" expand="full" class="ion-margin">Filter</ion-button> -->

        <DataTable :loading="loading" editMode="cell" dataKey="serial" :metaKeySelection="false" class="p-datatable-sm"
            showGridlines :value="myAllships" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"
            @page="onPage($event)"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            responsiveLayout="scroll" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
            <template #loading>
                Loading data, please wait...
            </template>
            <template #empty>
                No records found
            </template>
            <!-- <Column selectionMode="multiple" headerStyle="width: 3em">
            </Column> -->
            <Column field="Sl" header="#"></Column>
            <Column field="company" header="Company"></Column>
            <Column field="client" header="Client"></Column>
            <Column field="ship" header="Ship"></Column>
            <Column field="kam_name" header="KAM"></Column>
            <Column field="" header="Price" style="min-width:90px;">
                <template #body="{data}">
                    <strong>D:</strong> <span v-html="data.device_price"></span><br>
                    <strong>I:</strong> <span v-html="data.installation"></span> <br>
                    <strong>So:</strong> <span v-html="data.solar_price"></span> <br>
                    <strong>S:</strong> <span v-html="data.subscription_fee"></span> <br>
                </template>
            </Column>
            <Column field="" header="Confirmed By" style="min-width: 120px;">
                <template #body="{data}">
                    <strong v-html="data.confirmed_by"></strong> <br>
                    <span v-html="data.confirmed_at"></span>
                </template>
            </Column>
            <Column field="status" header="Status"></Column>
            <Column field="created_by" header="Created By" style="min-width: 120px;"></Column>
            <Column field="created_at" header="Created At" style="min-width: 120px;"></Column>
            <Column field="updated_at" header="Updated At" style="min-width: 120px;"></Column>
            <Column field="" header="Action">
                <template #body="{data}">
                    <router-link :to="'/my-ship-price-update/'+data.ship_id" v-if="data.kam_id == user.id">
                        <ion-button color="light">Update Price</ion-button>
                    </router-link>
                    <router-link :to="'/my-single-ship-pricing-log/'+data.ship_id">
                        <ion-button color="light">Log</ion-button>
                    </router-link>
                </template>
            </Column>
        </DataTable>
    </div>
</template>
<script>
    import {
        IonButtons,
        IonButton,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonTitle,
        IonToolbar,
        IonGrid,
        IonRow,
        IonCol,
        IonItem,
        IonLabel,
        IonSelect,
        IonSelectOption,
        alertController,
    } from '@ionic/vue';
    import {
        defineComponent
    } from 'vue'
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import Dropdown from 'primevue/dropdown';
    import Loading from '../../Loading';
    export default {
        name: 'AllShip',
        components: {
            DataTable,
            Column,
            Dropdown,
            IonButton,
            IonGrid,
            IonRow,
            IonCol,
            IonItem,
            IonLabel,
            IonSelect,
            IonSelectOption,
        },
        data() {
            return {
                companies:[],
                company:'',
                myAllships:[],
                myShip:{
                    name:null,
                    value: null
                },
                user:null,
                ships: [],
                clients:[],
                // ships:[],
                postData:{
                    'company_id':null,
                    'client_id':null,
                    'ship_id':null,
                },
                loading: false,
                perPage: 0,
                total: 0,
                pageCount: 0,
                searchData: {
                    deviceId: null,
                    deviceSerial: null,
                },
                popoverOpen: false,
                event: null,
            }
        },
        created(){
            const data = {
                'username': window.localStorage.username,
                'password': window.localStorage.password,
            };
            // this.$http.get('getCompany',).then(response=>{
            //     const coms=[];
            //     for(const com of response.data){
            //         coms.push({
            //             name:com.company_name,
            //             value:com.id
            //         });
            //     }
            // this.companies=coms;
            // });
            this.$http.post('MyShipPricingLog/MyAllCompanies', data).then(response => {
                const coms=[];
                for(const com of response.data.companies){
                    coms.push({
                        name:com.company_name,
                        value:com.id
                    });
                }
                this.companies=coms;
            });
        },
        mounted() {
            this.loadData(this.pageCount);

        },
        methods: {
            filterChange() {
                this.pageCount = 0;
                // this.$router.push(`/my-ship-pricing-log/${this.myShip.value}/${0}`);
                this.loadData(this.pageCount);
            },
            async presentResponseAlert(type, message) {
                const alert = await alertController
                    .create({
                        header: type + '!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },

            async loadData(page) {
                // const currentPage = parseInt(page!=0 ? page : (this.$route.params.page?this.$route.params.page:0));
                // this.pageCount = currentPage;
                // console.log(this.pageCount);
                this.pageCount = page;
                // const shipId = this.myShip.value;//?this.myShip.value:this.$route.params.shipId;
                const data = {
                    'page': page+1,
                    'company_id':this.postData.company_id,
                    'client_id':this.postData.client_id,
                    'ship_id':this.postData.ship_id,
                    'username': window.localStorage.username,
                    'password': window.localStorage.password,
                };
                this.loading = true;
                this.$http.post('MyShipPricingLog', data).then(response => {
                    this.perPage = response.data.SearchData.per_page;
                    this.total = response.data.SearchData.total;
                    this.user = response.data.user;
                    const ships = [];
                    let Sl = ((response.data.SearchData.current_page - 1) * this.perPage);
                    for (const ship of response.data.SearchData.data) {
                        Sl++;
                        ships.push({
                            'Sl': Sl,
                            'ship_id': ship.id,
                            'kam_id': ship.client.company.kam_id,
                            'kam_name': ship.client.company.kam.name,
                            'company': ship.client.company.company_name,
                            'client': ship.client.client_name,
                            'ship': ship.ship_name,
                            'device_price': parseInt(ship.device_price),
                            'installation': parseInt(ship.installation_charge),
                            'solar_price': parseInt(ship.solar_panel_price),
                            'subscription_fee': parseInt(ship.monthly_subscription_fee),
                            'confirmed_by': ship.current_ship_price_log ? ship
                                .current_ship_price_log.confirmed_by.name : '-',
                            'confirmed_at': ship.current_ship_price_log ? this.dateFormate(
                                ship.current_ship_price_log.confirmed_at,
                                'd-M-Y h:i:s A') : '',
                            'status': ship.current_ship_price_log ? ship
                                .current_ship_price_log.status : '-',
                            'created_by': ship.current_ship_price_log ? ship
                                .current_ship_price_log.created_by.name : '-',
                            'created_at': ship.current_ship_price_log ? this.dateFormate(
                                    ship.current_ship_price_log.created_at, 'd-M-Y h:i:s A'
                                    ) : '-',
                            'updated_at': ship.current_ship_price_log ? this.dateFormate(
                                    ship.current_ship_price_log.updated_at, 'd-M-Y h:i:s A'
                                    ) : '-',
                        });
                    }

                    this.myAllships = ships;
                    this.loading = false;
                });

            },
            onPage(event) {
                this.loadData(event.page);
            },
            dateFormate(data, formate) {
                if (!data) {
                    return '';
                }
                const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct',
                    'Nov', 'Dec'
                ];
                const date = new Date(data);
                let newDate = '';
                const dateFormate = formate.split('');
                for (const field of dateFormate) {
                    if (field == 'd') {
                        if (date.getDate() < 10) {
                            newDate += '0' + date.getDate();
                        } else {
                            newDate += date.getDate();
                        }
                    } else if (field == 'm') {
                        const month = date.getMonth() + 1;
                        if (month < 10) {
                            newDate += '0' + month;
                        } else {
                            newDate += month;
                        }
                    } else if (field == 'M') {
                        newDate += monthsShort[date.getMonth()];
                    } else if (field == 'y') {
                        newDate += date.getFullYear().toString().substr(2);
                    } else if (field == 'Y') {
                        newDate += date.getFullYear();
                    } else if (field == 'H') {
                        if ((date.getHours()) < 10) {
                            newDate += '0' + date.getHours();
                        } else {
                            newDate += date.getHours();
                        }
                    } else if (field == 'h') {
                        let hours = date.getHours();
                        if (date.getHours() > 12) {
                            hours = hours - 12;
                        }
                        if (date.getHours() == 0) {
                            hours = 12;
                        }

                        if (hours < 10) {
                            newDate += '0' + hours;
                        } else {
                            newDate += hours;
                        }
                    } else if (field == 'i') {
                        if (date.getMinutes() < 10) {
                            newDate += '0' + date.getMinutes();
                        } else {
                            newDate += date.getMinutes();
                        }
                    } else if (field == 's') {
                        if (date.getSeconds() < 10) {
                            newDate += '0' + date.getSeconds();
                        } else {
                            newDate += date.getSeconds();
                        }
                    } else if (field == 'A' || field == 'a') {
                        if (date.getHours() > 11) {
                            newDate += field == 'A' ? 'PM' : 'pm';
                        } else {
                            newDate += field == 'A' ? 'AM' : 'am';
                        }
                    } else {
                        newDate += field;
                    }
                }
                return newDate;
            },
            async companyChanged(){
                const loading = await Loading.presentLoading('Loading');
                this.postData['company_id']=this.company.value;
                this.postData['client_id']=null;
                this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
                    this.clients=response.data;
                    loading.dismiss();
                });
            },
            async clientChanged(){
                this.postData['ship_id']=null;
                const loading = await Loading.presentLoading('Loading');
                this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
                    this.ships=response.data;
                    loading.dismiss();
                });
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();

            },
            openPopover(e) {
                this.event = e;
                this.popoverOpen = true;
            },

        },
    }
</script>
